<template>
    <v-app>
      <v-content>
        <v-container fluid>
          <v-layout align-center justify-center>
            <v-card style="width: 700px">
              <v-card-title primary-title> </v-card-title>
              <v-flex>
                <v-form ref="form" v-model="form" class="pa-4 pt-6">
                  <label style="font-size: large">{{ $t("customers.editRestaurant.restaurantNameHeading") }}</label>
                  <v-text-field
                    outline
                    v-model="restaurant.name"
                    :label="$t('customers.editRestaurant.restaurantName')"
                    type="text"
                    :rules="[rules.required]"
                    style="margin-top: 15px"
                  ></v-text-field>
  
                  <v-flex>
                    <v-autocomplete
                      v-model="returnObject"
                      clearable
                      :items="addresses"
                      :loading="isLoading"
                      :search-input.sync="search"
                      outline
                      dense
                      :label="$t('customers.editRestaurant.address')"
                      item-text="text"
                      item-value="text"
                      :placeholder="$t('customers.editRestaurant.addressPlaceholder')"
                      :rules="[rules.required]"
                      no-filter
                      return-object
                    >
                      <template slot="item" slot-scope="addresses">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="addresses.item.text"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
  
                  <v-btn :loading="loading" block @click="save" color="secondary"
                    >{{ $t("customers.editRestaurant.save") }}
                  </v-btn>
                </v-form>
              </v-flex>
            </v-card>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </template>
  
  <script>
  export default {
    name: "Edit_Restaurant",
    title() {
      return this.$t("customers.editRestaurant.title");
    },
    components: {},
  
    data() {
      return {
        loading: false,
        form: false,
        address: "",
        addresses: [],
        returnObject: "",
        results: [],
        allResults: [],
        isLoading: false,
        search: null,
        error: false,
        restaurant: {
          name: "",
          address: "",
          pickup_location: {
            type: "Point",
            coordinates: [],
          },
          passenger_type: "RESTAURANT",
          landmark: "",
        },
        email: undefined,
        isLoading: false,
        password: undefined,
      };
    },
    computed: {
      rules() {
        return {
          length: (len) => (v) =>
            (v || "").length >= len ||
            this.$t("customers.editRestaurant.invalidLength", { length: len }),
          required: (v) => !!v || this.$t("customers.editRestaurant.requiredField"),
        };
      },
    },
    watch: {
      search(val) {
        this.isLoading = true;
        const params = new URLSearchParams(this.initialSearchParams);
        params.append("address", val);
        this.axios
          .get("address", { params })
          .then((res) => {
            this.addresses = res.data.data.map((item) => ({
              text:
                `${item.name || ""}` +
                " " +
                `${item.street_name || ""}` +
                " " +
                `${item.street_number || ""}`,
              ...item,
            }));
          })
          .catch((err) => console.log(err))
          .finally(() => (this.isLoading = false));
      },
    },
    created() {
      this.axios.get(`restaurant/${this.$route.params.id}`).then(({ data }) => {
        this.restaurant.name = data.data.name;
        this.restaurant.address = data.data.address;
        this.restaurant.pickup_location = data.data.pickup_location;
      });
    },
    methods: {
      save() {
        if (!this.$refs.form.validate()) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("customers.editRestaurant.fillAllData"),
            "red"
          );
          return;
        }
        this.loading = true;
  
        var ret = this.returnObject.text.replace("null ", "");
        this.restaurant.address = ret;
        if (this.returnObject.name) this.restaurant.landmark = this.returnObject.name;
        else if (this.returnObject.street_name)
          this.restaurant.landmark = this.returnObject.street_name;
  
        this.restaurant.pickup_location.coordinates = [];
        this.restaurant.pickup_location.coordinates.push(
          this.returnObject.centroid.coordinates[0]
        );
        this.restaurant.pickup_location.coordinates.push(
          this.returnObject.centroid.coordinates[1]
        );
  
        this.axios
          .put(`restaurant/${this.$route.params.id}`, {
            ...this.restaurant,
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.editRestaurant.restaurantSaved"));
            this.$router.push(`/restaurants`);
          })
          .catch(({ response }) => {
            window.getApp.$emit("SHOW_TOAST", this.$t("customers.editRestaurant.restaurantSaveFailed"), "red");
            console.log(response);
          })
          .finally(() => (this.loading = false));
      },
    },
  };
  </script>
  